import * as types from '../mutation-types'

const state = {
  job:'',
  calendarMonth: new Date(),

}
const getters = {
  selectedJobId: state => state.job.id,
  selectedJobTitle:state=> state.job.title,
  getJob: state => state.job,
  calendarMonth: state => state.calendarMonth,
}
const actions ={
  setJob({ commit, state }, data){
    commit(types.SET_SELECTED_JOB,data);
  },
  setLastJobCalendarMonth({ commit, state }, data){
    commit(types.SET_LAST_CALENDAR_MONTH, data);
  },
}
const mutations = {
  [types.SET_SELECTED_JOB] (state, data){
    state.job=data;
  },
  [types.SET_LAST_CALENDAR_MONTH] (state, data){
    state.calendarMonth=data;
  },
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/jobs.js